import Events from './Events'

export default class BackgroundLayer {
    static BACKGROUND_LAYER_CLASS = 'background-layer'
    static BACKGROUND_LAYER_ACTIVE_CLASS = 'background-layer--active'
    static BACKGROUND_BEHIND_HEADER_CLASS = 'background-layer--behind-header'
    static BODY_SCROLL_DISABLED_CLASS = 'body--scroll-disabled'

    constructor() {
        this.backgroundLayer = document.querySelector('.' + BackgroundLayer.BACKGROUND_LAYER_CLASS)
        this.initBackgroundLayer()
    }

    initBackgroundLayer() {
        this.backgroundLayer.addEventListener('click', () => {
            document.dispatchEvent(new Event(Events.CLICK_ON_BACKGROUND_LAYER_EVENT))
            this.deactivate()
        })
        document.addEventListener(Events.OPEN_NAVBAR_EVENT, () => {
            this.activate(true)
        })
        document.addEventListener(Events.CLOSE_NAVBAR_EVENT, () => {
            this.deactivate()
        })
    }

    disableScrolling() {
        document.body.classList.add(BackgroundLayer.BODY_SCROLL_DISABLED_CLASS)
    }

    enableScrolling() {
        document.body.classList.remove(BackgroundLayer.BODY_SCROLL_DISABLED_CLASS)
    }

    activate(behindHeader = false) {
        this.disableScrolling()
        this.backgroundLayer.classList.add(BackgroundLayer.BACKGROUND_LAYER_ACTIVE_CLASS)
        if (behindHeader) {
            this.backgroundLayer.classList.add(BackgroundLayer.BACKGROUND_BEHIND_HEADER_CLASS)
        }
    }

    deactivate() {
        this.enableScrolling()
        this.backgroundLayer.classList.remove(BackgroundLayer.BACKGROUND_LAYER_ACTIVE_CLASS)
        this.backgroundLayer.classList.remove(BackgroundLayer.BACKGROUND_BEHIND_HEADER_CLASS)
    }
}
